import {
  GETACCOUNTDATABYID,
  GETACCOUNTLIST,
  GETSINGLECATEGORY,
  GETSUBACCOUNTDATABYID,
} from "@/services/constant/apiPath";
import { ccwpApi } from "..";
import { maxPageSize } from "@/Constant";

export const configGetCategoryApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getCategoryByIdApiData: builder.query<any, any>({
      query: (categoryId) => GETSINGLECATEGORY + categoryId,
    }),
  }),
});
export const { useGetCategoryByIdApiDataQuery } = configGetCategoryApi;

export const configGetAccountApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccountByIdApiData: builder.query<any, any>({
      query: (caseId) => {
        return {
          url: GETACCOUNTLIST + caseId,
          params: {
            pageSize: maxPageSize,
            pageNumber: 1,
          },
        };
      },
    }),
    createAccount: builder.mutation({
      query: (data) => ({
        url: "/Account/CreateAccount",
        method: "POST",
        body: data,
      }),
    }),
    updateAccount: builder.mutation({
      query: (data) => ({
        url: "/Account/UpdateAccount",
        method: "PUT",
        body: data,
      }),
    }),
    updateSubAccount: builder.mutation({
      query: (data) => ({
        url: "/Account/UpdateSubAccount",
        method: "PUT",
        body: data,
      }),
    }),
    createSubAccount: builder.mutation({
      query: (data) => ({
        url: "/Account/CreateSubAccount",
        method: "POST",
        body: data,
      }),
    }),
    deleteAccount: builder.query({
      query: (id) => ({
        url: `Account/DeleteAccount?accountId=${id}`,
        method: "DELETE",
      }),
    }),
    deleteSubAccount: builder.query({
      query: (id) => ({
        url: `Account/DeleteSubAccount?subAccountId=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});
export const {
  useGetAccountByIdApiDataQuery,
  useCreateAccountMutation,
  useUpdateAccountMutation,
  useUpdateSubAccountMutation,
  useCreateSubAccountMutation,
  useLazyDeleteAccountQuery,
  useLazyDeleteSubAccountQuery,
} = configGetAccountApi;

export const configGetSubAccountApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubAccountByIdApiData: builder.query<any, any>({
      query: ({accountId,searchTerm}) => ({
        url: `Account/GetSubAccountListByAccount?AccountId=${accountId}`,
        params: { PageSize: maxPageSize, PageNumber: 1, SearchText: searchTerm },
      }),
    }),
  }), 
});
export const { useGetSubAccountByIdApiDataQuery } = configGetSubAccountApi;

export const configGetAccountDataByIDApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccountDataByIdApiData: builder.query<any, any>({
      query: (accoundId) => GETACCOUNTDATABYID + accoundId,
    }),
  }),
});
export const { useGetAccountDataByIdApiDataQuery } =
  configGetAccountDataByIDApi;

export const configGetSubAccountDataByIDApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubAccountDataByIdApiData: builder.query<any, any>({
      query: (subAccountId) => GETSUBACCOUNTDATABYID + subAccountId,
    }),
  }),
});
export const { useGetSubAccountDataByIdApiDataQuery } =
  configGetSubAccountDataByIDApi;
